import axios, { AxiosRequestConfig } from 'axios'
import {
  TransactionAiInsightFeedbackType,
  type TransactionAiInsights,
} from 'src/models/transaction.models'
import { getResponseData } from 'src/queries/network.utils'

export interface PutTransactionAiInsightFeedbackRequest {
  feedbackType: TransactionAiInsightFeedbackType
}

export const putTransactionAiInsightFeedback = async (
  transactionId: string,
  insightId: string,
  request: PutTransactionAiInsightFeedbackRequest,
  requestConfig: AxiosRequestConfig,
): Promise<TransactionAiInsights> => {
  return getResponseData(
    axios.put<TransactionAiInsights>(
      `/transactions/${transactionId}/ai-insights/${insightId}/feedback`,
      request,
      requestConfig,
    ),
  )
}
